import React from 'react';

import s from './VideoPopup.module.scss';

const VideoPopup = () => (
  <div className={s.VideoPopup} />

);

export default VideoPopup;
